const Report = () =>
  import(
    /* webpackChunkName: "courier-holding" */ '@/pages/courier/holding/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "courier-holding" */ '@/pages/courier/holding/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "courier-holding" */ '@/pages/courier/holding/edit.vue'
  )

export default {
  path: 'holding',
  meta: {
    label: 'holding',
    auth: 'holding'
  },
  component: {
    name: 'Company',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CompanyHoldingReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'CompanyCreateHolding',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CompanyEditHolding',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
